import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useVehicleVolumeType = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [vehicleVolumeTypeData, setVehicleVolumeTypeData] = useState<VehicleVolumeTypeInterface[]>([]);

    const onVehicleVolumeTypeError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err);
    };

    const onVehicleVolumeTypeSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<VehicleVolumeTypeInterface[]>) => {
        setVehicleVolumeTypeData(data ?? []);
    };

    const getVehicleVolumeTypeData = () => {
        const url: HttpConfig = {
            url: 'api/v1/company/fleet-volumes',
            method: 'get',

        };
        request(url, onVehicleVolumeTypeSuccess, setLoading, onVehicleVolumeTypeError);
    };

    return { getVehicleVolumeTypeData, loading, vehicleVolumeTypeData };
};

export default useVehicleVolumeType;


interface VehicleVolumeTypeInterface {
    name?: string;
    value?: number;
    color?: string;
    textColor?: string;
}

